import Rest from '../rest'

/******************************************************************************
 *  TeamFilter
 *****************************************************************************/



/**
 * @typedef {Object} Team
 * @property {number} id - O ID único da equipe.
 * @property {string} name - O nome da equipe.
 */

/**
 * @typedef {Object} ApiResponse
 * @property {string} status - O status da resposta ('success', 'error', etc.).
 * @property {Team[]} data - Um array de objetos do tipo Team.
 */

/**
 * @type {TeamFilter}
 */
export default class TeamFilter extends Rest {

    constructor () {
        super('/teams')
    }
    /**
     * Obtém todos os gerentes.
     * @param { {page: number, per_page: number} } [params]
     * @returns {Promise<ApiResponse>} Uma promessa que resolve para a resposta da API contendo os gerentes.
     */
    getTeams(params) {
        return this.getAllV2('', params)
    }
}